import gmt from '../gmt';

export default {
  mixins: [gmt],
  methods: {
    keyValues(release) {
      return [
        {
          label: 'Version',
          value: `${release.major}.${release.minor}.${release.build}`,
          icon: 'circle',
          centered: true,
        },
        {
          label: 'Released',
          value: release.released,
          icon: 'circle',
          id: release.uuid,
        },
        {
          label: 'Created',
          value: this.$options.filters.formatEpochDate(release.created, this.gmt),
          icon: 'cal',
        },
        {
          label: 'Modified',
          value: this.$options.filters.formatEpochDate(release.updated, this.gmt),
          icon: 'cal',
        },
      ];
    },
  },
};
